export type SessionErrorCode = 'unauthenticated' | 'permission-denied' | 'failed-precondition' | 'not-found' | 'invalid-argument' | 'unavailable'

export class SessionError extends Error {
  constructor(readonly code: SessionErrorCode, message: string) {
    super(message)
    this.name = 'SessionError'
  }
}

export function isRetryableSessionError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('code' in error)) return true
  return !['unauthenticated', 'permission-denied', 'failed-precondition', 'not-found', 'invalid-argument']
    .some(code => error.code === code || error.code === `functions/${code}`)
}
